import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 获取招标详情信息
export function getBidInfoApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/trades/${params.tradeId}/detail`,
    method: 'get'
  })
}

// 获取招标信息
export function getBidOrderApi(params) {
  const { orderId } = params
  return request({
    url: baseUrl + `/workbench/v2/supplier/bidding-orders/${orderId}/detail`,
    method: 'get',
    params
  })
}

// 提交报名信息
export function postApplyInfoApi(data) {
  return request({
    url:
      baseUrl + `/workbench/v2/supplier/bidding-orders/${data.orderId}/signup`,
    method: 'post',
    data: data
  })
}

// 修改报名信息
export function updateApplyInfoApi(data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${data.orderId}/trades/${data.tradeId}/signup`,
    method: 'put',
    data: data
  })
}

// 获取报名信息
export function getApplyInfoApi(query) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/bidding-orders/${query.tradeId}/signup-detail`,
    type: 'get'
  })
}

// 获取候选人公示信息
export function getCandidateInfoApi(query) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/bidding-orders/${query.orderId}/trades/${query.tradeId}/candidate-result`,
    method: 'get'
  })
}

// 供应商接受邀请
export function acceptBidInviteLetterApi(data, orderId, inviteId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/invites/${inviteId}/accept`,
    method: 'post',
    data
  })
}

// 供应商拒绝邀请
export function refuseBidInviteLetterApi(orderId, inviteId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/invites/${inviteId}/refuse`,
    method: 'post'
  })
}

// 标书费-业务请求下单
export function postBookFeePayApi({ ids }) {
  const { orderId, tradeId } = ids
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/book-fee-order`,
    method: 'post'
  })
}

// 查询支付状态
export function getBookFeePayStatusApi(params) {
  const { orderCode } = params
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/supplier/bidding-orders/pay-book-fee/${orderCode}`,
      method: 'get'
    },
    false
  )
}

// 查询邀请函信息
export function getInviteInfoApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/bidding-orders/${params.orderId}/invite/${params.inviteId}/find-invite-detail`,
    method: 'get'
  })
}

// 查询招标文件
export function previewSupplierBiddingFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/preview-bidding-file`,
    method: 'get',
    params
  })
}

// 下载招标文件
export function downloadSupplierBiddingFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/download-bidding-file`,
    method: 'get',
    params
  })
}

// 查询用户的预览和下载招标文件的状态
export function getSupplierDownloadBiddingFileStatusApi(orderId, params) {
  return request({
    url: `${baseUrl}/workbench/v2/supplier/bidding-orders/${orderId}/bidding-files/view-log`,
    method: 'get',
    params
  })
}

// 查询招标文件
export function getSupplierKpbFileApi(orderId, kpbFileId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/kpb-bidding-files/${kpbFileId}/detail`,
    method: 'get',
    params
  })
}

// 查询候选人历史记录
export function getCandidateHistoryApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/bid-candidates`,
    method: 'get'
  })
}

// 查询中标结果历史记录
export function getWinnerHistoryApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/bid-winners`,
    method: 'get'
  })
}

// 触发后端补发招标文件的数据更新
export function getReissueBiddingFile(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/trades/${params.tradeId}/view-reissue-file
      `,
    method: 'put'
  })
}

// 查询供应商的证件要求列表
export function getBidRequireListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/supplier/bidding-orders/${orderId}/owner-cert-require`,
    method: 'get'
  })
}

// 获取子账户的保证金账号
export function getBidSubAccountApi(data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${data.orderId}/trades/${data.tradeId}/refresh-account`,
    method: 'get'
  })
}

// 发起保证金退款
export function refundBidBondApi(data) {
  const { orderId, tradeId } = data
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-refund`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 查询文件澄清列表
export function supplierGetClarifiedFileApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/file-supplements`,
    method: 'get'
  })
}

// 触发查阅澄清文件的日志记录
export function supplierClarifiedViewApi(orderId, tradeId, supplementId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/file-supplements/${supplementId}/view-log`,
    method: 'post'
  })
}

// 查询结果通知书
export function previewSupplierResultFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/preview-notice-file`,
    method: 'get',
    params
  })
}

// 下载结果通知书
export function downloadSupplierResultFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${params.orderId}/trades/${params.tradeId}/download-notice-file`,
    method: 'get',
    params
  })
}

// 查看变更公告
export function getChangeFileApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/change-notices`,
    method: 'get'
  })
}

// 获取招标保函url
export function getOnlineLetterUrlApi(params) {
  return request({
    url: baseUrl + '/workbench/v2/supplier/bidding-orders/guarantee-letter/url',
    method: 'get',
    params
  })
}

// 招标电子保函结果查询
export function getGuaranteeLetterDetailApi(params) {
  const { orderId, tradeId } = params
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/guarantee-letter/${tradeId}/result`,
    method: 'get'
  })
}

// 招标电子保函退款
export function applyRefundLetterApi(data) {
  const { orderId, tradeId } = data
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/guarantee-letter/${tradeId}/refund`,
    method: 'post',
    data
  })
}

// 设置保证金缴费方式
export function setGuaranteePayMethodApi(orderId, tradeId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/guarantee-letter/${tradeId}/setUp`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}

// 创建保证金子账户
export function createGuaranteeAccountApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/guarantee-account`,
    method: 'post'
  })
}

// 线下保函提交审核
export function submitGuaranteeOfflineLetterApi(data) {
  const { orderId, tradeId } = data
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/guarantee-letter/${tradeId}/approval`,
    method: 'post',
    data
  })
}

// 代理服务费-业务请求下单
export function postAgentServiceFeePayApi(orderId, tradeId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/agent-fee-order`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    params
  })
}

// 中标单位提交融资申请
export function submitFinancingApplyApi(orderId, tradeId, winnerId, data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/financial-client/${winnerId}/trades/${tradeId}/add`,
    method: 'post',
    data
  })
}

// 平台服务费-业务请求下单
export function postWinnerServiceFeePayApi(orderId, tradeId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/supplier/bidding-orders/${orderId}/trades/${tradeId}/service-fee-order`,
    method: 'post',
    params
  })
}
